import { Button } from "@/shared/components/ui/button";
import { cn } from "@/shared/lib/utils";
import { useDarkMode } from "@/shared/hooks/useDarkMode";
import { MessageSquare } from "lucide-react";

interface FeedbackSidePanelProps {
  feedback: string;
  onResolve: () => void;
  isResolving?: boolean;
}

export function FeedbackSidePanel({ feedback, onResolve, isResolving }: FeedbackSidePanelProps) {
  const { darkMode } = useDarkMode();

  return (
    <div
      className={cn(
        "absolute left-full ml-4 top-0 w-[280px] p-4 rounded-lg shadow-lg border z-50",
        darkMode
          ? "bg-amber-950/40 border-amber-800 text-amber-200"
          : "bg-amber-50 border-amber-200 text-amber-900"
      )}
    >
      <div className="flex items-center gap-2 mb-3">
        <MessageSquare className={cn("h-4 w-4", darkMode ? "text-amber-400" : "text-amber-600")} />
        <span className={cn("text-sm font-semibold", darkMode ? "text-amber-300" : "text-amber-800")}>
          Admin Feedback
        </span>
      </div>
      <p className={cn("text-sm mb-4 whitespace-pre-wrap", darkMode ? "text-amber-300" : "text-amber-700")}>
        {feedback}
      </p>
      <Button
        size="sm"
        onClick={onResolve}
        disabled={isResolving}
        className={cn(
          "w-full",
          darkMode
            ? "bg-amber-600 text-white hover:bg-amber-500"
            : "bg-amber-600 text-white hover:bg-amber-700"
        )}
      >
        {isResolving ? "Resolving..." : "Resolve Feedback"}
      </Button>
    </div>
  );
}
